import { styled } from '@mui/material';

 import { Typography, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import { LogOutIcon } from '@app-velocity/icons';
import { useUserData, useLogout } from '@app-velocity/libs/auth';

const UserInfoContainer = styled('div')({
  background: 'var(--color-neutral-100)',
  border: '1px solid var(--color-neutral-300)',
  padding: '20px 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: 8,
});

const UserName = styled(Typography)({
  fontSize: 14,
  color: 'var(--color-neutral-900)',
  fontWeight: 500,
});

const LogOutButton = styled(Button)({
  color: 'var(--color-neutral-800)',
  display: 'flex',
  gap: 6,
  fontSize: 13,
  fontWeight: 400,
  svg: {
    fill: 'var(--color-neutral-600)',
    width: 20,
    height: 20,
  },
});

export const UserInfo = () => {
  const { userName } = useUserData();
  const { t } = useI18n();

  const logOut = useLogout();

  if (!userName) return null;

  return (
    <UserInfoContainer>
      <div>
        <UserName>{userName}</UserName>
        <Typography variant="body2">
          {t('prototypes:you_are_signed_in_as')}
        </Typography>
      </div>
      <LogOutButton variant="text" onClick={logOut}>
        {t('users:auth.sign_out')}
        <LogOutIcon />
      </LogOutButton>
    </UserInfoContainer>
  );
};
